// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"58":"1ff75f2d","214":"b39a97d6","250":"d8b51237","386":"fbf14808","458":"b7f7aff6","492":"36071ca8","577":"66801e42","652":"34876035","682":"d5252985","726":"3daeff63","783":"c66ca607","812":"e16e9c63","867":"56471a78","904":"0c67cfd9","985":"de897744"}[chunkId] + ".js";
};